import { useCallback } from 'react';

import { Box } from 'native-base';

import { useUnifiedMenuContext } from 'state/unified-menu';
import { getComboSlotDefaultItem } from 'state/unified-menu/utils';

import { useProductWizardContext } from '../../product-wizard';

import { ItemNutritionInformation } from './item-nutrition-information';

export const ComboNutritionInformation = () => {
  const { slotsSelections, selectedProduct } = useProductWizardContext();
  const { indexedMenu } = useUnifiedMenuContext();

  const getSlotSelections = useCallback(() => {
    if (Object.keys(slotsSelections).length > 1) {
      return Object.values(slotsSelections).map(comboSlot => indexedMenu.get(comboSlot?.itemId!));
    }
    // fallback to defaults on Step 1
    return (selectedProduct.options?.defaults || []).map(defaultItemId =>
      getComboSlotDefaultItem(indexedMenu, defaultItemId)
    );
  }, [slotsSelections, selectedProduct]);

  return (
    <Box>
      {getSlotSelections().map(item => (
        <ItemNutritionInformation key={item.id} item={item} />
      ))}
    </Box>
  );
};
